module.exports = function() {
  return new Worker(__webpack_public_path__ + "1a0893fd875b0d38d03d.worker.js");
};